import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { EditionsProvider as Provider } from '../../components/context/editions-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const EDITIONS_QUERY = graphql`
query NodeAllEditionsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Editions" } }) {
    nodes {
      data
    }
  }
}
`;

export const EditionsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(EDITIONS_QUERY), 'items')}>{children}</Provider>;
};
